import { IStyle } from '@fluentui/react';
import { ClassNamesFromIStyles, IH2OTheme, useClassNames } from '@h2oai/ui-kit';
import React from 'react';

import { classNameVisuallyHidden } from '../../themes/common';

interface IWidgetListFilterStyles {
  root: IStyle;
}

const widgetListFilterStyles = (_theme: IH2OTheme): Partial<IWidgetListFilterStyles> => ({
  root: {
    alignItems: 'center',
    border: 0,
    display: `flex`,
    flexWrap: `wrap`,
    margin: 0,
    minInlineSize: 0,
    padding: 0,

    // The fieldset legend is notoriously difficult to style, so we visually hide it and replace it with a sibling div.
    // @see https://adrianroselli.com/2022/07/use-legend-and-fieldset.html
    '& legend': [classNameVisuallyHidden],
    '& legend + div[aria-hidden]': {
      fontWeight: 700,
      marginInlineEnd: 8,
    },
  },
});

export type WidgetListFilterProps = {
  className?: string;
  styles?: Partial<IWidgetListFilterStyles>;
  children?: React.ReactNode;
};

export const WidgetListFilter = (props: WidgetListFilterProps) => {
  const classNames = useClassNames<IWidgetListFilterStyles, ClassNamesFromIStyles<IWidgetListFilterStyles>>(
    'widgetListFilter',
    widgetListFilterStyles,
    props.styles,
    props.className
  );

  return (
    <fieldset className={classNames.root}>
      <legend>Filter by</legend>
      <div aria-hidden="true">Filter by</div>
      {props.children}
    </fieldset>
  );
};
